import React from 'react';
import { FullPageLoader } from 'shared/components/loading';
import { useGetMenuCustomization } from '../data-access';
import { ThemeForm } from './theme-form';

export function Theme(): JSX.Element | null {
  const { data, loading } = useGetMenuCustomization();

  if (loading) {
    return <FullPageLoader />;
  }

  if (data) {
    return <ThemeForm data={data} />;
  }

  console.error(new Error(`missing web customization data`));
  return null;
}
